export default {
    accept_payments_for_nonclosed_visit: "Егер келу жабық болмаса, төлемді қабылдауға рұқсат ету",
    accountingmonth: "Бухгалтерлік айы",
    accrual: "Есептеу",
    accruals: "Есептеулер",
    accrued: "Есептелген",
    AQSI_account: "AQSI шот",
    balance_end: "Кезеңнің соңындағы баланс",
    balance_start: "Кезеңнің басындағы баланс",
    bonus_movement: "Бонустардың қозғалысы",
    cash_movements: "АҚ қозғалысы",
    cash_received: "АҚ алу",
    closed: "Жабу",
    communal: "коммуналдық төлемдер",
    deduct_materials_from_doctor_salary: "Дәрігердің жалақысынан материалдар сомасын шегеру",
    deduction: "Ұстау",
    deposit_account: "Депозиттік шот",
    deposit_accounts: "Депозиттік шоттар",
    deposit_balance: "Депозит қалдығы",
    deposit_balance_end: "Кезең соңындағы депозит қалдығы",
    deposit_balance_start: "Кезең басындағы депозит қалдығы",
    deposit_movement: "Депозит бойынша қозғалыстар",
    employee: "Қызметкерлер",
    employee_id: "Қызметкердің ID",
    expense: "Шығын",
    first_payment: "Алғашқы төлем",
    fiscal_cashdesk: "Қаржылық касса",
    for_payment_scan_this_qr_in_kyrgyz_bank: "Төлеу үшін осы QR кодын сканерлеп, Қырғызстандағы кез келген банкке төлеңіз",
    for_payment_scan_this_qr_in_obank_application: "Төлеу үшін OBank қолданбасында осы QR сканерлеңіз",
    income: "Кірістер",
    left_to_pay: "Төлеу қалды",
    left_to_pay2: "Төлеу қалды",
    manual_adjustments: "Қолмен түзету",
    materials_cost: "Материалдардың құны",
    materials_expense: "Шығын материалдары",
    open: "Ашу",
    opened: "Ашық",
    other_expense: "Басқа шығындар",
    other_income: "Басқа кірістер",
    pay_out: "Төлеу",
    payment_comment: "Төлеуге түсіндірмелер",
    payment_completed_successfully: "Төлем сәтті аяқталды",
    payment_sum: "Төлеу үшін сома",
    profit: "Кіріс",
    recalculate: "Қайта есептеу",
    refund_to_patient: "Пациентке қайтару",
    rent: "Жалдау",
    salaries: "Жалақы",
    unclosed: "Жабық емес",
    upselling: "Қосымша сатылым"
}
